import React, { useEffect, useState } from 'react';
import { LazyRender } from 'reaxl';

function LazyComponent({
    children,
    fallback = null,
    threshold,
    renderOnScroll = true,
}) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return fallback;
    }

    if (renderOnScroll) {
        return (
            <LazyRender
                fallback={fallback}
                threshold={threshold}
            >
                {children}
            </LazyRender>
        );
    }

    return children;
}

export default LazyComponent;
